module.exports = __webpack_public_path__ + "img/i_x_w.08eec89a.svg";